

















































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { vuex } from "@/store";
import rest from "@/rest";
import { List } from "linq-collections";
import AOS from 'aos'
import 'aos/dist/aos.css';
AOS.init();

// interfaces
import { CustomerMessageVm } from "@/interfaces/CustomerMessageVm";
// components
import Login from "@/components/Login.vue"; // @ is an alias to /src
import ContentFrameWithImage from "@/components/LandingPage/ContentFrameWithImage.vue";
import TopicSheet from "@/components/LandingPage/TopicSheet.vue";
import TopicSheet2 from "./TopicSheet2.vue";
import AnimatedButton from "../Shared/AnimatedButton.vue";
import SmallTopicWithIcon from "./SmallTopicWithIcon.vue";
import CompSequentialList from "../ExerciseComponents/CompSequentialList.vue";
import { ExChoiceList } from "@/interfaces/ExDataSet";

const globals = namespace("globals");
const ux = namespace("ux");

@Component({
  components: {
    Login,
    ContentFrameWithImage,
    SmallTopicWithIcon,
    TopicSheet,
    TopicSheet2,
    AnimatedButton,
    CompSequentialList
  },
})
export default class L3vincenzLandingPage extends Vue {
  @ux.Getter gradientBackground: any;
  @ux.Getter gradientBackground1: any;
  @ux.Getter gradientBackground2: any;
  @ux.Getter gradientBackground3: any;
  @ux.Getter gradientText: any;

  showLoginDialog: boolean = false;
  gdprAccepted = false;
  messageSending = false;

  menuItems = [
    {text: "Übersicht", value: "overview"},
    // {label: "Neuigkeiten", value: "news"},
    {text: "Preise", value: "prices"},
    {text: "Über uns", value: "aboutUs"},
    {text: "Kontakt", value: "contact"},
  ];
  selectedMenuItemValue = this.menuItems[0].value;
  selectedWindow = 0;
  isScrolled = false;
  isHeaderLogoVisible = false;
  observer: IntersectionObserver | null = null;

  // contact view
  kontaktFormValid = false;
  customerMsg = <CustomerMessageVm>{
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    phoneNumber: "",
    message: ""
  }

  $refs!: {
    observedElement: HTMLElement;
  };

  mounted() {
    // window.addEventListener('scroll', this.handleScroll);
    // Intersection Observers
    this.observer = new IntersectionObserver(this.handleIntersection, {
      // rootMargin: '0px', // Optional: Margin um das Wurzelelement
      threshold: 0.1 // Element gilt als sichtbar, wenn 10% davon sichtbar sind
    });

    // start observing the element
    if (this.$refs.observedElement) {
      this.observer.observe(this.$refs.observedElement);
    }
  }

  handleIntersection(entries) {
      entries.forEach(entry => {
        this.isHeaderLogoVisible = entry.isIntersecting;

        // console.log('Element visible: ', entry.isIntersecting ? 'yes' : 'no');
        // console.log('Visible part:', entry.intersectionRatio);
      });
    }
  beforeDestroy() {
    // window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    this.isScrolled = window.scrollY > 200;
  }
  openLoginDialog() {
    // value is use as trigger => just invert it
    this.showLoginDialog = !this.showLoginDialog;
  }

  onMenuItemClicked(item) {
    this.selectedMenuItemValue = item.value;
  }

  @Watch("selectedMenuItemValue")
  onMenuItemChanged(value) {
    let selectedItem = new List(this.menuItems).single(i => i.value == value);
    let idxOfSelectedItem = this.menuItems.indexOf(selectedItem);
    this.selectedWindow = idxOfSelectedItem;
  }

  selectPrevTab() {
    this.selectedWindow = this.selectedWindow - 1 < 0 ? 0 : this.selectedWindow - 1;
  }

  selectNextTab() {
    this.selectedWindow = this.selectedWindow + 1 === this.menuItems.length ? this.menuItems.length - 1 : this.selectedWindow + 1;
  }

  @Watch("selectedWindow")
  onCarouselDotSelectionChange(value) {
    let selectedItem = this.menuItems[this.selectedWindow];
    this.selectedMenuItemValue = selectedItem.value;
  }

  getMenuButtonColor(item) {
    if (this.selectedMenuItemValue == item.value) return this.$store.state.ux.colorAccent2;
    return "";
  }

  async onSendMessage() {
    this.messageSending = true;

    await rest.url("public/sendMessage")
      .post(this.customerMsg)
      .then((result) => {
        if (result !== true)
          return;

        vuex.ux.SB_SUCCESS({
          message: `Danke für Ihre Kontaktanfrage. Eine automatische Eingangsbestätigung wurde an Ihre Email Adresse ${this.customerMsg.email} versant.\r\nFalls Sie keine Nachricht erhalten haben, überprüfen Sie bitte auch Ihren Spam Email Ordner.`,
          timeout: 15000
        });
        this.customerMsg.firstName = "";
        this.customerMsg.lastName = "";
        this.customerMsg.company = "";
        this.customerMsg.email = "";
        this.customerMsg.phoneNumber = "";
        this.customerMsg.message = "";
        this.gdprAccepted = false;
        this.kontaktFormValid = true;
      })
      .finally(() => {
        this.messageSending = false
      });
  }

  get headLineStyle() {
    let lineStyle = "";
    if (this.$vuetify.breakpoint.xsOnly)
      lineStyle = "text-h5";
    else
      lineStyle = "text-h4";

    // if (this.darkTheme)
    //   lineStyle += " gradientDarkText";
    // else
    //   lineStyle += " gradientLightText";

    return lineStyle
  }

  // Horizontal padding in px depending on breakpoint: xs=50, md=100, lg=150
  get heroPaddingValue(): number {
    if ((this as any).$vuetify && (this as any).$vuetify.breakpoint) {
      const bp = (this as any).$vuetify.breakpoint;
      if (bp.xsOnly) return 30;
      if (bp.lgAndUp) return 150;
      return 80; // md / sm
    }
    return 50;
  }

  get heroStyle() {
    return {
      width: '100%',
      padding: `0px ${this.heroPaddingValue}px`,
      backgroundColor: (this as any).$store?.state?.ux?.colorAccent1,
      position: 'relative',
      boxSizing: 'border-box'
    };
  }

  mailRules = [
    (v: string) => !!v || "Email is required",
    (v: string) =>
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        v
      ) || "Keine gültige E-Mail-Adresse"
  ];

  firstNameRules = [
    (v: string) => !!v || "Vorname erforderlich",
    (v: string) => (v && v.length > 1) || "Vornamename zu kurz."
  ];

  lastNameRules = [
    (v: string) => !!v || "Nachname erforderlich",
    (v: string) => (v && v.length > 1) || "Nachname zu kurz."
  ];

  messageRules = [
    (v: string) => !!v || "Nachricht erforderlich",
    (v: string) => (v && v.length > 9) || "Nachricht zu kurz."
  ];
}
